// Сборка строки запроса. Один экземпляр на все наборы эндпоинтов: два разных сборщика
// разъезжаются в мелочи, которая ловится не сборкой, а пустым экраном у человека.
//
// Два правила.
//
// **`undefined` и `null` не попадают в адрес вовсе.** «?active=undefined» сервер разберёт как
// непустую строку и молча вернёт не тот срез.
//
// **Список значений уезжает ПОВТОРАМИ ключа**, а не через запятую: `?status=submitted&
// status=accepted`. Так это и ждёт сервер (`list[str] = Query(...)` в FastAPI). Строка через
// запятую пришла бы одним значением «submitted,accepted», отбор не совпал бы ни с чем, и
// человек увидел бы пустую очередь вместо своих заявок.

export type QueryValue = string | number | boolean | undefined | null;

export function queryString(
  params: Readonly<Record<string, QueryValue | readonly QueryValue[]>>,
): string {
  const parts: string[] = [];
  for (const [name, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        if (item === undefined || item === null) {
          continue;
        }
        parts.push(`${name}=${encodeURIComponent(String(item))}`);
      }
      continue;
    }
    parts.push(`${name}=${encodeURIComponent(String(value))}`);
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}
